/**
 * @file Tooltip 提示
 * @description 基于 antd Tooltip 封装
 */
import type {TooltipProps as AntdTooltipProps} from 'antd';
import {Tooltip as AntdTooltip} from 'antd';
import styles from './index.module.less';
import {createCx, mergeSemanticClassNames} from '@/utils/cx';

const cx = createCx(styles);

interface TooltipProps extends AntdTooltipProps {
    // 是否强制不换行
    nowrap?: boolean;
}

const Tooltip = ({nowrap, classNames, ...restProps}: TooltipProps) => {
    const mergedClassNames = mergeSemanticClassNames(
        {
            root: cx('root', {'nowrap': nowrap}),
            container: cx('container', {'nowrap': nowrap}),
            arrow: cx('arrow'),
        },
        classNames,
    );

    return <AntdTooltip arrow={false} classNames={mergedClassNames} {...restProps} />;
};

export default Tooltip;
